"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidRequest = exports.SmartContratError = exports.EntityNotFound = exports.HttpAwareError = void 0;
class HttpAwareError extends Error {
    constructor(message, type, status) {
        super(message);
        this.type = type;
        this.status = status;
    }
    JSON() {
        return {
            type: this.type,
            message: this.message,
            status: this.status,
        };
    }
}
exports.HttpAwareError = HttpAwareError;
class EntityNotFound extends HttpAwareError {
    constructor(entityName) {
        super(`Cannot find ${entityName}`, 'ENTITY_NOT_FOUND', 404);
    }
}
exports.EntityNotFound = EntityNotFound;
class SmartContratError extends HttpAwareError {
    constructor(contractName) {
        super(`Error while calling contract:${contractName}`, 'CONTRACT_ERROR', 503);
    }
}
exports.SmartContratError = SmartContratError;
class InvalidRequest extends HttpAwareError {
    constructor(errors) {
        super('Request contains invalid data', 'INVALID_REQUEST', 400);
        this.errors = errors;
    }
    JSON() {
        return Object.assign(Object.assign({}, super.JSON()), { errors: this.errors });
    }
}
exports.InvalidRequest = InvalidRequest;
//# sourceMappingURL=errors.js.map